// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.methanol_suggestion_clear_enum */
var MethanolSuggestionClearEnum;
(function (MethanolSuggestionClearEnum) {
    MethanolSuggestionClearEnum["SCORE_FELL"] = "SCORE_FELL";
    MethanolSuggestionClearEnum["ABSTAINED"] = "ABSTAINED";
    MethanolSuggestionClearEnum["RUN_ENDED"] = "RUN_ENDED";
    MethanolSuggestionClearEnum["SNOOZED"] = "SNOOZED";
    MethanolSuggestionClearEnum["TURNED_OFF"] = "TURNED_OFF";
})(MethanolSuggestionClearEnum || (MethanolSuggestionClearEnum = {}));
;
export default MethanolSuggestionClearEnum;
/** Zod schema for methanol_suggestion_clear_enum */
export const methanolSuggestionClearEnum = z.nativeEnum(MethanolSuggestionClearEnum);
//# sourceMappingURL=MethanolSuggestionClearEnum.js.map